import { render, staticRenderFns } from "./UserManagementPage.vue?vue&type=template&id=10da6cc6&scoped=true&"
import script from "./UserManagementPage.vue?vue&type=script&lang=js&"
export * from "./UserManagementPage.vue?vue&type=script&lang=js&"
import style0 from "./UserManagementPage.vue?vue&type=style&index=0&id=10da6cc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10da6cc6",
  null
  
)

export default component.exports